import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=59b9ddda&scoped=true"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9ddda",
  null
  
)

export default component.exports